export enum GARAAZ_PERSONNEL_SUB_TYPES {
  USTAAD = "USTAAD",
}
